import React from "react";

import IconButton from "@material-ui/core/IconButton";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import SettingsIcon from "@material-ui/icons/Settings";

const OSSActionMenuCell = ({ column, row }) => {
  const { actionMenuType, actionMenuIcon, onClick } = column;
  const { id, state } = row;
  const buttonId = `${actionMenuType}-action-cell-${id}`;

  const handleClick = e => {
    e.stopPropagation();
    onClick(buttonId, actionMenuType, row);
  };

  const canDownload = state => {
    return state === "ready" || state === "published";
  };

  const reportCanBeEdited = () => {
    const { modified_by } = row;
    // This blocks a report from surfacing editable actions if the user is defined as a bot
    return modified_by.first_name !== "" && modified_by.last_name !== "";
  };

  const CellIcons = {
    settings: <SettingsIcon />,
    download: <CloudDownloadIcon color="primary" />
  };

  return (
    ((actionMenuType === "download" && canDownload(state)) ||
      (actionMenuType !== "download" && reportCanBeEdited())) && (
      <IconButton id={buttonId} onClick={handleClick}>
        {CellIcons[actionMenuIcon]}
      </IconButton>
    )
  );
};

export default OSSActionMenuCell;
